@use "../../style/mixins" as *;
@use "../../style/variables" as *;

.dashboard {
  min-height: 100%;
  background-color: $white;
  margin-left: auto;
  margin-right: auto;

  @include mobile {
    width: 100%;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

.sticky-menu-wrapper {
  display: flex;
  flex: 1 0 0;
  flex-direction: row;
  width: 100%;
}

.profile-wrapper {
  margin-left: auto;
  margin-right: auto;

  @include mobile {
    width: 100%;
    padding: 0;
  }
}